import "../../css/Containers/ContainerStyles.css";
import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import PopupModalContainer, {
  PopupModalContainerWidth,
} from "./PopupModalContainer";
import {
  MARKIT_DOCS,
  MARKIT_HOTLINE_NUMBER,
  MARKIT_IG,
  MARKIT_LINKEDIN,
  MARKIT_SUPPORT_EMAIL,
  MARKIT_X,
} from "@markit/common.utils";
import { formatPhoneNumber } from "../../utils/FormatPhoneNumber";
import { CopyableLinkDisplay } from "../Links/CopyCustomLinkify";
import { useCallback } from "react";
import { isDesktop } from "react-device-detect";

type HelpModalProps = {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  alternateSubtext?: string;
};

const HelpModal = (props: HelpModalProps) => {
  const { showModal, setShowModal, alternateSubtext } = props;

  const renderSupportOption = useCallback(
    (url: string, iconName: string, text: string) => (
      <div
        className="AlignedRowSelect"
        style={{ gap: 10 }}
        onClick={() => window.open(url)}
      >
        <Icon icon={iconName} height={16} />
        <span>{text}</span>
      </div>
    ),
    []
  );

  return (
    <>
      {showModal ? (
        <PopupModalContainer
          headerComp={
            <div className="ColumnNormal" style={{ gap: 14 }}>
              <Icon icon="ion:help-circle" height={40} />
              <div className="ColumnNormal" style={{ gap: 7 }}>
                <span className="sectionTitle">Contact Support</span>
                <span className="bodySubtext">
                  {alternateSubtext ||
                    "Ask us any questions or report an issue. Text our hotline number below, email us, or DM our socials."}
                </span>
              </div>
              <div className="ColumnNormal bodyRegular" style={{ gap: 7 }}>
                {renderSupportOption(
                  MARKIT_DOCS,
                  "ion:globe-outline",
                  "Visit Markit Docs for Tutorials & More"
                )}
                {renderSupportOption(
                  `mailto:${MARKIT_SUPPORT_EMAIL}`,
                  "ion:mail",
                  MARKIT_SUPPORT_EMAIL
                )}
                {renderSupportOption(MARKIT_IG, "mdi:instagram", "@markit_ai")}
                {renderSupportOption(
                  MARKIT_X,
                  "fa6-brands:square-x-twitter",
                  "@markit_ai__"
                )}
                {renderSupportOption(
                  MARKIT_LINKEDIN,
                  "ion:logo-linkedin",
                  "Markit AI"
                )}
              </div>
            </div>
          }
          valueComp={
            <div className="ColumnNormal" style={{ gap: 7 }}>
              <div className="AlignedRow" style={{ gap: 7 }}>
                <Icon icon="ion:chatbubble-ellipses" height={16} />
                <span className="bodyMedium">Text our hotline</span>
              </div>
              <CopyableLinkDisplay
                copyText={formatPhoneNumber(MARKIT_HOTLINE_NUMBER)}
                containerStyles={{
                  display: "flex",
                  padding: 14,
                  borderColor: Colors.GRAY1,
                  borderWidth: 0.5,
                }}
                altTextColor={Colors.BLACK}
              />
            </div>
          }
          noExit
          closeOnOutsidePress
          closeModal={() => setShowModal(false)}
          modalContentWidth={
            isDesktop
              ? PopupModalContainerWidth.NORMAL
              : PopupModalContainerWidth.SMALL
          }
        />
      ) : null}
    </>
  );
};

export default HelpModal;
